(function () {
  'use strict';
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var menoMoto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var propria = typeof window.avviaPagina === 'function';
  function euro(n) {
    try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(n); }
    catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  }
  window.EURO = euro;
  function stelle() {
    $$('.stelle[data-v]').forEach(function (el) {
      var v = parseFloat(el.getAttribute('data-v')) || 5, h = '';
      for (var i = 1; i <= 5; i++) {
        var p = Math.max(0, Math.min(1, v - i + 1));
        h += '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.4l-5.8 3.1 1.1-6.5L2.6 9.4l6.5-.9z" ' +
             'opacity="' + (p > .5 ? 1 : p > 0 ? .45 : .18) + '"/></svg>';
      }
      el.innerHTML = h;
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', v + ' su 5');
    });
  }
  function menu() {
    var b = $('#hamb'), n = $('#menu'); if (!b || !n) return;
    b.addEventListener('click', function () {
      var a = n.classList.toggle('on');
      b.setAttribute('aria-expanded', String(a));
    });
    $$('a', n).forEach(function (a) {
      a.addEventListener('click', function () {
        n.classList.remove('on'); b.setAttribute('aria-expanded', 'false');
      });
    });
  }
  function domande() {
    $$('.acc__q').forEach(function (q) {
      var i = q.closest('.acc__i');
      q.setAttribute('aria-expanded', String(!!(i && i.classList.contains('on'))));
      q.addEventListener('click', function () {
        var i = q.closest('.acc__i');
        var a = i.classList.toggle('on');
        q.setAttribute('aria-expanded', String(a));
      });
    });
  }
  function video() {
    var tutti = $$('.vid');
    if (!tutti.length) return;
    function zittisci(tranne) {
      tutti.forEach(function (b) {
        var v = $('video', b);
        if (!v || b === tranne) return;
        v.muted = true; b.classList.remove('audio');
        var t = $('.vid__play', b);
        if (t) { t.setAttribute('aria-pressed', 'false'); t.setAttribute('aria-label', "Attiva l'audio"); }
      });
    }
    tutti.forEach(function (b) {
      var v = $('video', b); if (!v) return;
      v.muted = true; v.playsInline = true;
      if (!b.classList.contains('vid--seq')) v.loop = true;
      function segna() {
        var t = $('.vid__play', b);
        if (!t) return;
        t.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        t.setAttribute('aria-label', v.muted ? "Attiva l'audio" : 'Togli l\'audio');
      }
      segna();
      b.addEventListener('click', function () {
        if (v.muted) { zittisci(b); v.muted = false; b.classList.add('audio'); v.play(); }
        else { v.muted = true; b.classList.remove('audio'); }
        segna();
      });
    });
    $$('.scorri--seq').forEach(function (riga) {
      var box = $$('.vid', riga);
      if (!box.length) return;
      box.forEach(function (b, i) {
        var v = $('video', b);
        v.loop = false;
        v.addEventListener('ended', function () {
          if (!v.muted) return;
          var p = $('video', box[(i + 1) % box.length]);
          if (p) { p.currentTime = 0; p.play().catch(function(){}); }
        });
      });
    });
    if ('IntersectionObserver' in window) {
      var oss = new IntersectionObserver(function (voci) {
        voci.forEach(function (x) {
          var v = $('video', x.target); if (!v) return;
          if (x.isIntersecting) { if (v.paused && !x.target.classList.contains('vid--seq')) v.play().catch(function(){}); }
          else if (!v.paused) { v.pause(); }
        });
      }, { threshold: .25 });
      tutti.forEach(function (b) { oss.observe(b); });
    }
  }
  function galleria() {
    if (propria) return;
    var g = $('.pdp__gal'); if (!g) return;
    var grande = $('#galGrande', g); if (!grande) return;
    $$('.gal__m', g).forEach(function (m, i) {
      m.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      m.addEventListener('click', function () {
        var img = $('img', m);
        grande.src = img.getAttribute('data-full') || img.src;
        grande.alt = img.alt;
        $$('.gal__m', g).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        m.setAttribute('aria-current', 'true');
      });
    });
  }
  var scelto = null;
  function formati() {
    var g = $('#formati'); if (!g) return;
    var righe = $$('.opz__b', g);
    if (!righe.length) return;
    if (propria) {
      righe.forEach(function (b) {
        b.addEventListener('click', function () {
          var i = $('#stickyPh'), s = b.getAttribute('data-img');
          if (i && s) { i.src = s; i.hidden = false; }
        });
      });
      var g0 = righe.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0];
      if (g0) {
        var i0 = $('#stickyPh'), s0 = g0.getAttribute('data-img');
        if (i0 && s0) i0.src = s0;
      }
      return;
    }
    function scegli(b) {
      righe.forEach(function (x) {
        x.setAttribute('aria-checked', String(x === b));
        x.setAttribute('tabindex', x === b ? '0' : '-1');
      });
      scelto = {
        id:   b.getAttribute('data-id'),
        nome: nomeProdotto() || b.getAttribute('data-nome'),
        sub:  b.getAttribute('data-nome') || b.getAttribute('data-sub') || '',
        p:    parseFloat(b.getAttribute('data-p')),
        img:  b.getAttribute('data-img') || ''
      };
      var pz = $('#buyPrezzo') || $('#prezzoOra');  if (pz) pz.textContent = euro(scelto.p);
      var ba = $('#buyBarrato') || $('#prezzoPrima'); if (ba) {
        var s = b.getAttribute('data-barrato') || b.getAttribute('data-prima');
        ba.textContent = s ? euro(parseFloat(s)) : '';
        ba.hidden = !s;
      }
      var ri = $('#buyRisparmio'); if (ri) {
        var r = b.getAttribute('data-risparmio');
        ri.textContent = r || ''; ri.hidden = !r;
      }
      aggiornaBarra();
    }
    righe.forEach(function (b) {
      b.setAttribute('role', 'radio');
      b.addEventListener('click', function () { scegli(b); });
      b.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); scegli(b); return; }
        var d = {ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1}[e.key];
        if (!d) return;
        e.preventDefault();
        var i = righe.indexOf(b), n = righe[(i + d + righe.length) % righe.length];
        scegli(n); n.focus();
      });
    });
    scegli(righe.filter(function (b) {
      return b.hasAttribute('data-scelto') || b.getAttribute('aria-checked') === 'true';
    })[0] || righe[0]);
  }
  function nomeProdotto() {
    var e = $('.buy h1') || $('.pdp h1') || $('main h1');
    return e ? e.textContent.trim() : '';
  }
  function aggiornaBarra() {
    var b = $('#sticky'); if (!b) return;
    var n = $('#stickyNome'), p = $('#stickyPrezzo'), i = $('#stickyPh');
    if (!scelto) return;
    if (n) n.textContent = scelto.nome + (scelto.sub ? ' · ' + scelto.sub : '');
    if (p) p.textContent = euro(scelto.p);
    if (i && scelto.img) { i.src = scelto.img; i.hidden = false; }
  }
  function barra() {
    var b = $('#sticky'); if (!b) return;
    var bottone = $('#stickyBtn');
    if (bottone && !bottone.getAttribute('href')) {
      bottone.addEventListener('click', function () {
        var h = b.getAttribute('data-href');
        if (h) { window.location.href = h; return; }
        var r = $('#acquisto') || $('#formati');
        if (r) r.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    var rif = $('.buy') || $('.hero') || $('#principale > *');
    if (rif && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (voci) {
        voci.forEach(function (x) {
          b.classList.toggle('su', !x.isIntersecting && x.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(rif);
      return;
    }
    var atteso = false;
    window.addEventListener('scroll', function () {
      if (atteso) return;
      atteso = true;
      requestAnimationFrame(function () {
        b.classList.toggle('su', window.scrollY > window.innerHeight * 0.6);
        atteso = false;
      });
    }, { passive: true });
  }
  function reveal() {
    var dentro = $('main');
    if (!dentro) return;
    function fuori(e) {
      return e.closest('.head, .foot, .drw, .barra, .ann, .menu');
    }
    var RIGHE = '.scorri, .gr, .opz, .punti, .hm-cta, .cta, .stelle';
    function parte(e) {
      if (e.matches('h1, h2')) return 'titolo';
      if (e.matches('.ph, .vid, figure, picture, .banner__ph, .gal__m, .ba')) return 'media';
      if (e.matches('img, video') && !e.closest('.ph, .vid, figure, picture, .banner__ph, .gal__m, .ba')) return 'media';
      if (e.matches('.card, .kit, .opz__b, .col3, .faq, details')) return 'scheda';
      return 'testo';
    }
    function attori(scena) {
      var out = [];
      (function scendi(nodo, prof) {
        for (var c = nodo.firstElementChild; c; c = c.nextElementSibling) {
          if (fuori(c) || c.matches('script, style, br, source, svg')) continue;
          var suo = c.matches('h1, h2, h3, p, ul, ol, blockquote, img, video, figure, picture, ' +
                              '.ph, .vid, .banner__ph, .ba, .card, .kit, .col3, .faq, details, ' +
                              RIGHE);
          if (suo) { out.push(c); continue; }
          if (prof < 4) scendi(c, prof + 1);
        }
      })(scena, 0);
      return out;
    }
    var scene = $$('main > section, main > .banner, main > .sez, ' +
                   'main > [id^="shopify-section"] > section, ' +
                   'main > [id^="shopify-section"] > .banner, ' +
                   'main > [id^="shopify-section"] > .sez');
    if (!scene.length) scene = [dentro];
    var tutti = [];
    scene.forEach(function (scena) {
      var lista = attori(scena);
      if (!lista.length) return;
      var testi = [], media = [];
      lista.forEach(function (e) {
        (parte(e) === 'media' ? media : testi).push(e);
      });
      var ordinati = testi.concat(media);
      ordinati.forEach(function (e, i) {
        e.setAttribute('data-an', parte(e));
        e.style.setProperty('--an-i', Math.min(i, 8));
        tutti.push(e);
      });
      lista.forEach(function (e) {
        if (!e.matches(RIGHE)) return;
        var n = 0;
        for (var c = e.firstElementChild; c; c = c.nextElementSibling) {
          c.style.setProperty('--an-i', Math.min(n++, 8));
          c.setAttribute('data-an', 'scheda');
          tutti.push(c);
        }
      });
    });
    if (menoMoto || !('IntersectionObserver' in window)) {
      tutti.forEach(function (e) { e.classList.add('vai'); });
      return;
    }
    var oss = new IntersectionObserver(function (voci) {
      voci.forEach(function (x) {
        if (!x.isIntersecting) return;
        x.target.classList.add('vai');
        x.target.querySelectorAll('[data-an]').forEach(function (f) {
          f.classList.add('vai');
        });
        oss.unobserve(x.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    tutti.forEach(function (e) {
      if (e.parentElement && e.parentElement.closest('[data-an]')) return;
      oss.observe(e);
    });
    function salvaVisibili() {
      tutti.forEach(function (e) {
        if (e.classList.contains('vai') || e.classList.contains('mostra')) return;
        var b = e.getBoundingClientRect();
        if (b.top < window.innerHeight && b.bottom > 0) {
          e.classList.add('mostra');
          e.querySelectorAll('[data-an]').forEach(function (f) { f.classList.add('mostra'); });
        }
      });
    }
    setTimeout(salvaVisibili, 2500);
    window.addEventListener('scroll', function () {
      clearTimeout(reveal.t);
      reveal.t = setTimeout(salvaVisibili, 1800);
    }, { passive: true });
  }
  function testataScorre() {
    var h = $('.head');
    if (!h) return;
    var atteso = false;
    function agg() {
      h.classList.toggle('giu', window.scrollY > 8);
      document.documentElement.style.setProperty('--head-b',
        Math.max(0, Math.round(h.getBoundingClientRect().bottom)) + 'px');
      atteso = false;
    }
    agg();
    window.addEventListener('scroll', function () {
      if (atteso) return;
      atteso = true;
      requestAnimationFrame(agg);
    }, { passive: true });
  }
  function moduli() {
    var tr = $('#trForm');
    if (tr) {
      tr.addEventListener('submit', function (e) {
        e.preventDefault();
        ['#trVuoti', '#trNulla', '#trTecnico'].forEach(function (s) {
          var d = $(s); if (d) d.hidden = true;
        });
        var n = ($('#trNumero') || {}).value || '';
        var m = ($('#trEmail') || {}).value || '';
        var t = $(!n.trim() || !m.trim() ? '#trVuoti' : '#trNulla');
        if (t) { t.hidden = false; t.focus(); }
      });
    }
    var ct = $('#ctForm');
    if (ct) {
      ct.addEventListener('submit', function (e) {
        e.preventDefault();
        var campi = [['#ctNome', '#ctNomeE'], ['#ctMail', '#ctMailE'], ['#ctMsg', '#ctMsgE']];
        var primo = null;
        campi.forEach(function (c) {
          var i = $(c[0]), err = $(c[1]);
          if (!i) return;
          var vuoto = !i.value.trim();
          if (c[0] === '#ctMail' && !vuoto) vuoto = !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(i.value.trim());
          if (err) err.classList.toggle('on', vuoto);
          i.setAttribute('aria-invalid', String(vuoto));
          if (vuoto && !primo) primo = i;
        });
        if (primo) { primo.focus(); return; }
        var t = $('#ctTrappola');
        if (t && t.value) { ct.hidden = true; return; }
        ct.hidden = true;
        var ok = $('#ctOk');
        if (ok) { ok.hidden = false; ok.focus(); }
      });
    }
    var cp = $('#ctCopia');
    if (cp) {
      cp.addEventListener('click', function () {
        var testo = 'tryrootz@outlook.it', fatto = function () {
          var v = cp.textContent; cp.textContent = 'Copiato';
          setTimeout(function () { cp.textContent = v; }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(testo).then(fatto, function () {});
        } else {
          var a = document.createElement('textarea');
          a.value = testo; document.body.appendChild(a); a.select();
          try { document.execCommand('copy'); fatto(); } catch (e) {}
          a.remove();
        }
      });
    }
  }
  function avvia() {
    stelle(); menu(); domande(); video(); galleria();
    formati(); barra(); aggiornaBarra();
    reveal(); testataScorre(); moduli();
    if (typeof window.avviaPagina === 'function') window.avviaPagina();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();